let keyMethod = [
  'GENERATE',
  'IMPORT',
  'EXIST'
]

export default keyMethod
